<quick-dashboard
  [loader]="loader"
  (childRouteDeactivated)="reload('childRouteDeactivated')"
  [uid]="'rag-sessions-dashboard'"
  [heading]="'Sessions'"
  [columnOptions]="{
    '$$raw': { hidden: true },
    'id': { hidden: true },
    'name': { heading: 'Name', order: 1, renderTemplate: cellName },
    'chatbot': { heading: 'Assistant', order: 2, renderTemplate: cellChatbot, outerNgClass: 'cell-width-200' },
    'description': { hidden: true },
    'createdBy': { heading: 'Owner', order: 4, outerNgClass: 'cell-width-280', renderTemplate: cellOwner },
    'templateId': { hidden: true },
    'templateName': { hidden: true },
    'template': { heading: 'Template', renderTemplate: cellTemplate, order: 3, },
    'lastAccessedAt': { heading: 'Activity', renderTemplate: cellLastAccess, order: 4, hidden: !isExtendedView },
    'actions': {
      heading: 'Actions',
      order: 60,
      renderTemplate: cellActions,
      outerNgClass: 'align-middle cell-width-140'
     }
  }"
  [hasRouterOutlet]="true"
>
</quick-dashboard>

<ng-template #cellLastAccess let-cellItem=cellItem>
  <div class="text-secondary fw-light">
    <div *ngIf="cellItem">
      <uptime-view
        [ngClass]="'fw-light text-secondary'"
        [greedy]="true"
        [dateRange]="{
          'start': cellItem,
          'end': now
        }"
      >
      </uptime-view> ago
    </div>
    <div *ngIf="!cellItem">-</div>
  </div>
</ng-template>

<ng-template #cellOwner let-cellItem=cellItem>
  <user-id-tag
    [userId]="cellItem"
  ></user-id-tag>
</ng-template>

<ng-template #cellActions let-rowItem=rowItem>
  <div>
    <preview-button ngClass="me-1" [routerLink]="['./preview', rowItem['id']]"></preview-button>
    <a
      [routerLink]="['./preview', rowItem['id'], 'chat']" class="ms-1">
      <mat-icon class="valign-middle">chat</mat-icon>
    </a>
    <a
      matTooltip="Create a new session with the same assistant & template"
      [ngClass]="'ms-2'"
      [routerLink]="['./manage']"
      [queryParams]="{
          'source': rowItem['id']
        }"
    >
      <mat-icon class="valign-middle">content_copy</mat-icon>
    </a>
    <delete-button
      [useLinkButton]="true"
      [disabled]="rowItem['isSystem']"
      [ngClass]="'ms-1'"
      [routerLink]="rowItem['isSystem'] ? [] : ['./delete', rowItem['id']]"
    ></delete-button>
  </div>
</ng-template>

<ng-template #cellName let-rowItem=rowItem>
  <div>{{rowItem['name']}}</div>
  <div class="text-secondary fw-light font-size-14">{{rowItem['description']}}</div>
</ng-template>

<ng-template #cellChatbot let-rowItem=rowItem>
  <a class="link-underline-light" target="_blank" [routerLink]="['/chatbots', rowItem['chatbot']]">
    {{rowItem['chatbot']}}
  </a>
</ng-template>

<ng-template #cellTemplate let-rowItem=rowItem>
  <a class="link-underline-light" target="_blank" [routerLink]="['/templates/preview', rowItem['templateId']]">
    {{rowItem['templateName']}}
  </a>
</ng-template>
